module.exports = __webpack_public_path__ + "static/kapsulki_kawa-95278d3cf17baa5674edca109fc5e228.png";